import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ theme, displayState }) => css`
    white-space: ${displayState?.width ? '' : 'nowrap'};
    position: absolute;
    padding: 12px;
    top: -10px;
    left: 50%;
    width: ${displayState?.width ?? ''};
    -webkit-transform: translate(-50%, -100%);
    transform: translate(-50%, -100%);
    text-align: ${displayState?.textAlign ?? 'center'};
    background: ${theme?.colour?.secondary};
    color: white;
    font-size: 12px;
    z-index: 10;
    border-radius: 6px;
    white-space: ${displayState?.whiteSpace ? displayState?.whiteSpace : 'pre-wrap'};

    &:after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: ${theme?.colour?.secondary} transparent transparent transparent;
    }


    ${displayState?.direction === 'bottom' && css`
      top: unset;
      margin-top: 10px;
      transform: translate(-50%, 0%);

      &:after {
        top: -10px;
        border-color: transparent transparent ${theme?.colour?.secondary} transparent;
      }

      ${displayState?.offset && css`
        left: ${`${displayState?.offset === 'start' ? '-10px' : 'calc(100% + 10px)'}`};
        transform: ${`translate(${displayState?.offset === 'start' ? '0%' : '-100%'}, 0%)`};

        &:after {
          left: ${`${displayState?.offset === 'start' ? '10px' : 'calc(100% - 20px)'}`};
          margin-left: 0px;
        }
      `}
    `}

    ${displayState?.direction === 'right' && css`
      left: calc(100% + 10px);
      top: 50%;
      transform: translate(0%, -50%);

      &:after {
        top: calc(50% - 5px);
        left: -5px;
        border-color: transparent ${theme?.colour?.secondary} transparent transparent;
      }
    `}

    ${displayState?.direction === 'left' && css`
      left: auto;
      right: calc(100% + 10px);
      top: 50%;
      transform: translate(0%, -50%);

      &:after {
        top: calc(50% - 5px);
        left: auto;
        right: -10px;
        border-color: transparent transparent transparent ${theme?.colour?.secondary};
      }
    `}



  `}
`;

export default Atom({ type: 'label', dataType: 'string', template });


// const template = styled.span`
//   ${({ theme, displayState }) => css`
//     position: absolute;
//     padding: 12px;
//     top: -10px;
//     left: 50%;
//     max-width: 200px; /* Set a maximum width */
//     width: auto; /* Allow the width to adjust based on content */
//     white-space: pre-wrap; /* Allow wrapping if content exceeds max-width */
//     word-wrap: break-word; /* Ensures long words break to the next line */
//     overflow-wrap: break-word; /* Modern alternative for word-wrap */
//     -webkit-transform: translate(-50%, -100%);
//     transform: translate(-50%, -100%);
//     text-align: ${displayState?.textAlign ?? 'center'};
//     background: ${theme?.colour?.secondary};
//     color: white;
//     font-size: 12px;
//     z-index: 10;
//     border-radius: 6px;

//     &:after {
//       content: "";
//       position: absolute;
//       top: 100%;
//       left: 50%;
//       margin-left: -5px;
//       border-width: 5px;
//       border-style: solid;
//       border-color: ${theme?.colour?.secondary} transparent transparent transparent;
//     }

//     ${displayState?.direction === 'bottom' && css`
//       top: unset;
//       margin-top: 10px;
//       transform: translate(-50%, 0%);

//       &:after {
//         top: -10px;
//         border-color: transparent transparent ${theme?.colour?.secondary} transparent;
//       }

//       ${displayState?.offset && css`
//         left: ${`${displayState?.offset === 'start' ? '-10px' : 'calc(100% + 10px)'}`};
//         transform: ${`translate(${displayState?.offset === 'start' ? '0%' : '-100%'}, 0%)`};

//         &:after {
//           left: ${`${displayState?.offset === 'start' ? '10px' : 'calc(100% - 20px)'}`};
//           margin-left: 0px;
//         }
//       `}
//     `}

//     ${displayState?.direction === 'right' && css`
//       left: calc(100% + 10px);
//       top: 50%;
//       transform: translate(0%, -50%);

//       &:after {
//         top: calc(50% - 5px);
//         left: -5px;
//         border-color: transparent ${theme?.colour?.secondary} transparent transparent;
//       }
//     `}

//     ${displayState?.direction === 'left' && css`
//       left: auto;
//       right: calc(100% + 10px);
//       top: 50%;
//       transform: translate(0%, -50%);

//       &:after {
//         top: calc(50% - 5px);
//         left: auto;
//         right: -10px;
//         border-color: transparent transparent transparent ${theme?.colour?.secondary};
//       }
//     `}
//   `}
// `;


// export default Atom({ type: 'label', dataType: 'string', template });
